var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentFinished(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3752 63.75H109.202C114.58 63.75 119.406 59.8462 119.948 54.495C120.568 48.3544 115.708 43.125 109.688 43.125H73.444C70.399 43.125 67.6671 40.845 67.5096 37.8019C67.339 34.5581 69.919 31.875 73.1252 31.875H82.9521C88.3296 31.875 93.1559 27.9713 93.6977 22.62C94.3184 16.4794 89.4584 11.25 83.4377 11.25H61.8752H47.8127H19.6877C13.9915 11.25 9.37523 15.8663 9.37523 21.5625C9.37523 27.2588 13.9915 31.875 19.6877 31.875H26.2502C28.3221 31.875 30.0002 33.5531 30.0002 35.625C30.0002 37.6969 28.3221 39.375 26.2502 39.375H12.5852C8.1846 39.375 4.23585 42.57 3.79335 46.9463C3.28523 51.9712 7.2621 56.25 12.1877 56.25H24.0565C27.1015 56.25 29.8334 58.53 29.9909 61.5731C30.1615 64.8169 27.5815 67.5 24.3752 67.5H18.2102C13.8096 67.5 9.86085 70.695 9.41835 75.0712C8.9121 80.0962 12.8871 84.375 17.8127 84.375H26.0496C27.9171 84.375 29.6496 85.6519 29.9496 87.495C30.3302 89.8444 28.5284 91.875 26.2502 91.875H18.2102C13.8096 91.875 9.86085 95.07 9.41835 99.4462C8.91023 104.471 12.8871 108.75 17.8127 108.75H59.0627C59.224 108.75 59.374 108.711 59.5315 108.703C59.689 108.716 59.839 108.75 60.0002 108.75H92.599C95.7302 108.75 98.5896 106.646 99.2309 103.581C100.11 99.3713 96.8777 95.625 92.8127 95.625H82.7009C80.8334 95.625 79.1009 94.3481 78.8009 92.505C78.4202 90.1556 80.2221 88.125 82.5002 88.125H105.54C109.941 88.125 113.89 84.93 114.332 80.5519C114.838 75.5287 110.863 71.25 105.938 71.25H99.5759C97.7084 71.25 95.9759 69.9731 95.6759 68.13C95.2952 65.7806 97.0971 63.75 99.3752 63.75Z",
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4325 28.192L47.7788 77.8458L22.5675 52.567C19.9781 49.9776 15.7819 49.9776 13.1925 52.567C10.6031 55.1564 10.6031 59.3526 13.1925 61.942L42.855 91.6701C45.5756 94.3908 49.9856 94.3908 52.7063 91.6701L106.809 37.567C109.399 34.9777 109.399 30.7814 106.809 28.192C104.22 25.6027 100.022 25.6027 97.4325 28.192Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8752 60) scale(53.6419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#BBF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 60,
    y1: 26.2495,
    x2: 60,
    y2: 93.7101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42D778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#3DCA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B171"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentFinished);
export default __webpack_public_path__ + "static/media/content-finished.44d16397.svg";
export { ForwardRef as ReactComponent };